import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const PB = '/nhan-su/phong-ban'
const CD = '/nhan-su/chuc-danh'

// Phòng ban
export function layDanhSachPhongBan(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${PB}/danh-sach-phong-ban`, { params: query })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layChiTietPhongBan(departmentId: number) {
  try {
    return axiosApi.get(`${PB}/${departmentId}/chi-tiet-phong-ban`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function taoPhongBan(params: any) {
  try {
    return axiosApi.post(`${PB}/tao-phong-ban`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function capNhatPhongBan(departmentId: number, params: any) {
  try {
    return axiosApi.put(`${PB}/${departmentId}/cap-nhat-phong-ban`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function xoaPhongBan(departmentId: number) {
  try {
    return axiosApi.delete(`${PB}/${departmentId}/xoa-phong-ban`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chức danh
export function layDanhSachChucDanh() {
  try {
    return axiosApi.get(`${CD}/danh-sach-chuc-danh`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function taoChucDanh(params: any) {
  try {
    return axiosApi.post(`${CD}/tao-chuc-danh`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function capNhatChucDanh(jobTitleId: number, params: any) {
  try {
    return axiosApi.put(`${CD}/${jobTitleId}/cap-nhat-chuc-danh`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function xoaChucDanh(jobTitleId: number) {
  try {
    return axiosApi.delete(`${CD}/${jobTitleId}/xoa-chuc-danh`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
